// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"d2c4e1ec","766":"63bc4117"}[chunkId] + ".chunk.js";
};